import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

const links = [
  { to: "/home-improvement", label: "Home Improvement" },
  { to: "/tenant-improvement", label: "Tenant Improvement" },
  { to: "/forum", label: "Forum" },
  { to: "/blog", label: "Blog" },
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/contractors", label: "Contractors" },
  { to: "/brand", label: "Brand Kit" },
];

export default function Footer() {
  return (
    <footer className="border-t border-border" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-8">
        <div className="flex flex-col justify-between gap-8 md:flex-row">
          <div className="max-w-xs">
            <Link to="/" className="flex items-center gap-2.5">
              <img src="/logo.png" alt="Costobuild" className="h-9 w-9" />
              <span className="font-heading text-lg font-extrabold uppercase tracking-tight">Costobuild</span>
            </Link>
            <p className="mt-2 font-mono2 text-[11px] uppercase tracking-[0.25em] text-primary">From Plans to Possibility</p>
            <p className="mt-3 text-sm text-muted-foreground">
              Design any structure and get instant, worldwide cost estimates with material and labor breakdowns —
              anywhere on Earth, in your local currency.
            </p>
          </div>
          <nav className="grid grid-cols-2 gap-x-10 gap-y-3 sm:flex sm:flex-wrap">
            {links.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="font-mono2 text-xs uppercase tracking-widest text-muted-foreground transition-colors hover:text-primary">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="mt-10 border-t border-border pt-6 font-mono2 text-xs uppercase tracking-widest text-muted-foreground">
          © {new Date().getFullYear()} Costobuild · Worldwide construction estimates
        </div>
      </div>
    </footer>
  );
}
